import { Component, EventEmitter, Input, OnInit, Output, OnChanges, OnDestroy } from '@angular/core';
import { GlobalVariableService } from 'src/app/core/services/global-variable.service';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-solde-analyse',
  templateUrl: './solde-analyse.component.html',
  styleUrls: ['./solde-analyse.component.css']
})
export class SoldeAnalyseComponent implements OnInit {
  public clickEventSubscription: Subscription;

  @Output() refreshSoldes = new EventEmitter();
  @Input() details_solde;
  @Input() allowBlockSelection = false;
  @Input() selectedBlocks: string[] = ['promo', 'aug', 'gratif', 'bonus', 'eff_aug'];
  @Output() selectedBlocksChange = new EventEmitter<string[]>();

  private static nextSelectorId = 0;
  public blockSelectionId = `solde-blocs-${++SoldeAnalyseComponent.nextSelectorId}`;
  public classifications = ['IC', 'AM', 'OE'];
  public blockOptions = [
    { key: 'promo', title: 'Promotions', background: '#000', color: '#fff',
      situation: 'total_agents', budget: 'promo_effectif_alloue', realise: 'realise_eff_promo' },
    { key: 'aug', title: 'Augmentation en FCFA', background: '#7f8c8d', color: '#fff',
      situation: 'total_salaire_net', budget: 'aug_alloue', realise: 'realise_montant_aug' },
    { key: 'gratif', title: 'Gratification en FCFA', background: '#bdc3c7', color: '#000',
      situation: 'total_salaire_brut', budget: 'gratif_alloue', realise: 'realise_montant_gratif' },
    { key: 'bonus', title: 'Bonus en FCFA', background: '#ecf0f1', color: '#000',
      situation: 'total_salaire_net', budget: 'bonus_alloue', realise: 'realise_montant_bonus' },
    { key: 'eff_aug', title: 'Effectif augmentation total (promotion et augmentation simple)', background: '#ecf0f1', color: '#000',
      situation: 'total_agents', budget: 'aug_effectif_alloue', realise: 'realise_eff_aug' }
  ];
  public blockRows = [
    { key: 'situation', title: 'Situation', categoryPrefix: '', totalPrefix: 'total_situation_' },
    { key: 'budget', title: 'Budget Alloué', categoryPrefix: '', totalPrefix: 'total_budget_' },
    { key: 'realise', title: 'Réalisés', categoryPrefix: '', totalPrefix: 'total_realise_' },
    { key: 'ecart', title: 'Ecart', categoryPrefix: 'ecart_', totalPrefix: 'total_ecart_' },
    { key: 'pourcentage', title: '% Réalisés', categoryPrefix: 'pourcentage_', totalPrefix: 'total_prct_' },
    { key: 'pourcentage_ecart', title: '% Ecart', categoryPrefix: 'pourcentage_ecart_', totalPrefix: 'total_prct_ecart_' }
  ];

  public detailsSoldeAM: any;
  public detailsSoldeIC: any;
  public detailsSoldeOE: any;
  public detailsSolde: any;
  public user: any;

  public get visibleBlocks() {
    return this.blockOptions.filter(block => (this.selectedBlocks || []).includes(block.key));
  }

  public onBlocksChange(blocks: string[]): void {
    this.selectedBlocks = blocks || [];
    this.selectedBlocksChange.emit(this.selectedBlocks);
  }

  public get showPercentageEcart(): boolean {
    return ['directeur', 'responsable-ofa', 'pvch-exceptionnel', 'pvch-eia'].includes(this.user?.profil?.slug);
  }

  public getBlockValue(block: any, row: any, classification?: string): any {
    const solde = classification ? this.detailsSolde?.[classification] : this.detailsSolde;
    const field = classification
      ? block[row.key] || row.categoryPrefix + block.key
      : row.totalPrefix + block.key;
    return solde?.[field] ?? '--';
  }

  public getBlockPercentageClass(block: any, classification: string): string {
    const value = this.detailsSolde?.[classification]?.['pourcentage_' + block.key];
    const rate = this.detailsSolde?.['taux_' + block.key];
    if (value == null || rate == null) {
      return '';
    }
    const percentage = Number(String(value).replace(/\s/g, '').replace(',', '.'));
    const threshold = Number(String(rate).replace(/\s/g, '').replace(',', '.'));
    return isNaN(percentage) || isNaN(threshold) ? '' : percentage <= threshold ? 'green' : 'red';
  }

  constructor(
    private variable: GlobalVariableService,
    private sharedService: SharedDataService,
  ) {
    //refresh page to update table solde
    // this.refresh.emit()
    this.clickEventSubscription = this.sharedService.getClickEventRefreshTableSoldesAnalyse().subscribe(() => {
      this.getSoldesAnalyse();
      // location.reload();
    });
  }


  ngOnInit() {
    this.user = JSON.parse(this.variable.getUser());
    this.getSoldesAnalyse();
  }

  ngOnChanges() {
    this.getSoldesAnalyse();
    // this.detailsSolde;
  }

  ngOnDestroy() {
    /* Always unsubscribe (or use takeUntil, etc.) */
    if (this.clickEventSubscription) {
      this.clickEventSubscription.unsubscribe();
    }
  }


  getSoldesAnalyse() {
    this.detailsSoldeAM = this.details_solde?.AM;
    this.detailsSoldeIC = this.details_solde?.IC;
    this.detailsSoldeOE = this.details_solde?.OE;
    this.detailsSolde = this.details_solde;
    //refresh page to update table solde
    this.refreshSoldes.emit("refresh");
  }
}
